export enum InvoiceComplianceMode {
  Default = 'default',
  French = 'french',
}
